"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const frLocaleData = require("i18next-icu/locale-data/fr");
exports.default = frLocaleData;
//# sourceMappingURL=fr.js.map